<template>
  <div id="trailReportsTV">

    <div class="row mb-0 mt-2" id="top-row">
      <div class="col-md-7">
        <WeatherTV />
      </div><!-- /.col-md-6 -->
      <div class="col-md-5">
        <div class="card notes">
          <div class="card-body" v-if="trailsDetails.updates && trailsDetails.updates.notice">
            <p style="text-align:center;"><strong><i class="fas fa-bullhorn"></i> Trail Notes</strong></p>
            <p v-for="(notice, i) in trailsDetails.updates.notice" v-bind:key="i">{{ notice.description }} <i>~Updated: {{ notice.updatedOn | toDate }}</i></p>
          </div><!-- /.card-body -->
        </div>
      </div><!-- /.col-md-5 -->
    </div><!-- /.row -->

    <!-- Trail Summaries -->
    <div class="row">
      <div style="margin:10px auto;z-index:1;" v-if="trailsDetails.updates && trailsDetails.updates.snowReport">
        <!-- <span class="pill"><i class="fas fa-map-signs"></i> {{ trailsDetails.data.records.openLength }} kilometers open</span> -->
        <span class="pill"><i class="fas fa-snowflake"></i> {{ trailsDetails.updates.snowReport[0].twentyFourHours }}" in last 24 hrs.</span>
        <span class="pill"><i class="fas fa-snowflake"></i> {{ trailsDetails.updates.snowReport[0].fourtyEightHours }}"  in last 48 hrs.</span>
        <span class="pill"><i class="fas fa-snowflake"></i> {{ trailsDetails.updates.snowReport[0].seasonTotal }}" all season</span>
      </div>
    </div><!-- /.row -->

    <!-- Trail Cards -->
    <div class="row" :class="tilesClass" id="cardRow">
      <div
        class="col-md-2 trail-tile"
        v-for="trail in trails.slice(trailTilesStart, trailTilesEnd)"
      >
        <div class="card trail-card">
          <div
            class="card-header"
            :class="trail.status"
            v-html="$options.filters.toFa(trail.status)"
          >
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-10">
                <h5 class="card-title">{{ trail.name }}</h5>
                <p><i class="fas fa-map-signs"></i> {{ trail.distance  | trimNumber }} km.</p>
              </div><!-- /.col-md-10 -->
              <div class="col-md-2">
                <span class="dot" :class="trail.difficulty"></span>
              </div><!-- /.col-md-2 -->
            </div>
            <p
              v-if="trail.Notes || trail.SurfaceCondition"
            >{{ trail.Notes }} {{ trail.SurfaceCondition }}</p>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-3 -->
    </div><!-- /.row -->

  </div><!-- /#trailReportsTV -->
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import WeatherTV from './WeatherTV'
  import moment from 'moment'

  export default {
    components: {
      WeatherTV
    },
    data() {
      return {
        trails: [],
        trailsDetails: {},
        trailTilesStart: 0,
        trailTilesEnd: 30,
        tilesClass: 'active'
      }
    },
    computed: {
      ...mapState(['dashboard'])
    },
    mounted () {
      let self = this
      setTimeout(function() {
        let timeStamp = new Date().getTime()
        let orgAPI = self.dashboard.data.modules.trailHub.orgAPIAccessKey
        let locAPI = self.dashboard.data.modules.trailHub.locationActivityAPIKey
        let tsID = self.dashboard.data.modules.trailHub.tsID
        axios.get('https://trailhub.org/api/trails/' + tsID + '?timestamp=' + timeStamp).then(response => {
            self.trails = response.data
          })
        axios.get('https://trailhub.org/api/ts/' + tsID + '?timestamp=' + timeStamp)
          .then(response => {
            self.trailsDetails = response.data
          })
      }, 1000)
      // let self = this
      // setTimeout(function() {
      //   let timeStamp = new Date().getTime()
      //   let orgAPI = self.dashboard.data.modules.trailHub.orgAPIAccessKey
      //   let locAPI = self.dashboard.data.modules.trailHub.locationActivityAPIKey
      //   // CRAFTSBURY MTB TRAILS APIS
      //   axios
      //     .get('https://www.trailhub.org/webservice/api/gettraildetailsinfo?OrgAPIAccessKey=' + orgAPI + '&LocationActivityAPIKey=' + locAPI + '&timestamp=' + timeStamp)
      //     .then(response => {
      //       self.trails = response
      //       self.animateTiles()
      //     })
      //   axios
      //     .get('https://www.trailhub.org/webservice/api/getorgcounts?OrgAPIAccessKey=' + orgAPI + '&LocationActivityAPIKey=' + locAPI + '&timestamp=' + timeStamp)
      //     .then(response => {
      //       self.trailsDetails = response
      //     })
      // }, 1000)
      // CRAFTSBURY SKI TRAILS APIS
      // axios
      //   .get('https://www.trailhub.org/webservice/api/gettraildetailsinfo?OrgAPIAccessKey=7ec7508410a3a94a7d072222832fbd57&LocationActivityAPIKey=TVRVeExURTFMVGd0T0RBNExURTFNUT09&timestamp=' + timeStamp)
      //   .then(response => {
      //     this.trails = response
      //     this.animateTiles()
      //   })
      // axios
      //   .get('https://www.trailhub.org/webservice/api/getorgcounts?OrgAPIAccessKey=7ec7508410a3a94a7d072222832fbd57&LocationActivityAPIKey=TVRVeExURTFMVGd0T0RBNExURTFNUT09&timestamp=' + timeStamp)
      //   .then(response => {
      //     this.trailsDetails = response
      //   })
    },
    methods: {
      animateTiles() {
        let self = this
        self.tilesClass = 'active'
        console.log(self.trailTilesStart)
        let screenWillFit = 30
        let tileCount = self.trails.data.records.length
        setTimeout(function() {
          let me = self
          me.tilesClass = 'inactive'
          setTimeout(function() {
            if ((me.trailTilesStart + screenWillFit) > tileCount) {
              me.trailTilesStart = 0
              me.trailTilesEnd = screenWillFit
            } else {
              me.trailTilesStart = me.trailTilesStart + screenWillFit
              me.trailTilesEnd = me.trailTilesEnd + screenWillFit
            }
            me.animateTiles()
          }, 1000)
        }, 10000)
      }
    },
    filters: {
      toFa(value) {
        if (value == "C") {
          let fa = '<i class="fas fa-times-circle"></i> Closed'
          return fa
        }
        if (value == "CA") {
          let fa = '<i class="fas fa-exclamation-circle"></i> Caution'
          return fa
        }
        if (value != "C" && value != "CA") {
          let fa = '<i class="fas fa-check-circle"></i> Open'
          return fa
        }
      },
      toDate(val) {
        if (!val) { return '-' }
        var t = new Date(1970, 0, 1)
        t.setSeconds(val._seconds)
        return moment(t).format('MM/DD/YY - hh:mm a')
      },
      trimNumber (value) {
        return parseFloat(value).toFixed(2)
      },
    }
  }
</script>

<style scoped>
  .row {
    margin-left: 0px;
    margin-right: 0px;
  }
  #cardRow {
    transition: all 0.3s ease;
    height: calc(100vh - 300px);
    overflow: scroll;
  }
  .card {
    border: none;
    min-height: 96%;
  }
  .trail-card .card-header {
    color: white;
    font-weight: bold;
  }
  .trail-card .Open {
    background-color: rgba(0,128,0,0.8);
  }
  .trail-card .Caution {
    background-color: rgba(255,165,1,0.8);
  }
  .trail-card .Closed {
    background-color: rgba(255,0,0,0.8);
  }
  .trail-card .col-md-10, .trail-card .col-md-6, .trail-card .col-md-2, .trail-card .row, .trail-card .card-body, .trail-card p, .trail-card h5, .trail-card .card-header {
    margin-bottom: 0;
    padding: 0;
  }
  .trail-card .card-header {
    padding: 10px;
  }
  .trail-card .card-body {
    padding: 10px 10px 0 10px;
    max-height: 100px;
    overflow: hidden;
  }
  .trail-card h5 {
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
  }
  .trail-card .dot {
    margin-top: 5px;
    width: 30px;
    height: 30px;
  }
  .trail-card .dot.Easy {
    border-radius: 15px;
  }
  .trail-card p {
    font-size: 12px;
    line-height: 1;
  }
  .notes {
    background-color: #333;
    color: #eee;
  }
  #trailReportsTV {
    position: absolute;
    height: 100vh;
    overflow: hidden;
    background-color: #333;
    left: 0;
    margin: 0;
  }
  #top-row {
    height: 185px;
  }
  .active {
    opacity: 1;
  }
  .inactive {
    opacity: 0;
  }
  .pill {
    background-color: white;
    border-radius: 4px;
    padding: 10px 20px;
    margin: 5px;
    margin-bottom: 20px;
    color: #333;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tv/TrailReportsTV.vue